const confirmButton = document.querySelector('.popup-confirmation-button');
const customizeAnotherButton = document.querySelector('.popup-another');

const cartLinkButton = document.querySelector('.flask-checkout-link');
const popupUpsell = document.querySelector('#popup-upsell');
let flaskGiftNote = "";

cartLinkButton.addEventListener('click', (e) =>{
  e.preventDefault();
});

confirmButton.addEventListener('click', async (e) => {
  const res = await checkout('confirm');
  if(res != 422)
  location.href = '/cart';
});

customizeAnotherButton.addEventListener('click', async (e) => {
  await checkout();
});

popupUpsell.addEventListener('click', async (e) => {
  e.preventDefault();
  await checkout('confirm');
  location.href = '/collections/sunnies-flask';
});



let formData = {
 'items': []
};

function addParent(id, bundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': bundleID
        }
    });
}

function addBottleComponent(id, bundleID, engravingID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': bundleID,
          '_bottleEngravingID': engravingID,
          '_order_url': window.location.href
        }
    });
}
function addCapComponent(id, parentBundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID
        }
    });
}
function addLoopComponent(id, parentBundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID
        }
    });
}
function addBootComponent(id, parentBundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID
        }
    });
}
function addEngravingComponent(id, parentBundleID, engravingID, engravingText, item_type, engravingPlacement, engravingColor, engravingOrientation = 'Horizontal', engravingFont) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID,
          '_isBundleComponent': true,
          '_bottleEngravingID': engravingID,
          '_engravingPlacement': engravingPlacement,
          '_engravingOrientation': engravingOrientation,
          '_engravingColor': engravingColor,
          '_engravingFontFamily': engravingFont,
          'Engraving': engravingText
        }
    });
}
function addGliderComponent(id, parentBundleID, item_type) {
    formData.items.push({
        'id': id,
        'quantity': 1,
        'properties': {
          '_item_type': item_type,
          '_bundleID': parentBundleID
        }
    });
    console.log('formData', formData)
}


async function checkout(method){
  
  customizationMain.classList.add('loading-icon');
  
  document.querySelector('.preview-popup .popup-wrapper').classList.add('loading-icon');
  let bundleID = Date.now() + Math.floor(Math.random()*(100-1+1)+1);
  let bottleEngravingID = 'Bottle_' + bundleID;


  if(bottleBundleVariantID.length > 1 && capBundleVariantID.length > 1 && loopBundleVariantID.length){
    getCapType() == 'robo' ? gliderActive ? addGliderComponent('42526525587574', bundleID, 'flask_bundle') : addGliderComponent('42526525685878', bundleID, 'flask_bundle') : '';
    if (!document.querySelector('.flask-customization-main').classList.contains('no_engraving')){
      engravingValue.length > 1 ? addEngravingComponent('40526024867958', bundleID, bottleEngravingID, engravingValue, 'flask_bundle', engravingPlacement, engravingColor, engravingOrientation, engravingFont) : '';
    }
    (bootVariantID.length > 1 && bottleSizeOption != '64oz') && (bootVariantID.length > 1 && bottleSizeOption != '40oz') ? addBootComponent(bootVariantID, bundleID, 'flask_bundle') : '';
    addLoopComponent(loopBundleVariantID, bundleID, 'flask_bundle');
    addCapComponent(capBundleVariantID, bundleID, 'flask_bundle');
    addBottleComponent(bottleBundleVariantID, bundleID, bottleEngravingID, 'flask_bundle');
    
  }
  else{
    bottleBundleVariantID.length > 1 ? addBottleComponent(bottleIndividualVariantID, '', bottleEngravingID, 'flask') : '';
    capBundleVariantID.length > 1 ? addCapComponent(capIndividualVariantID, '', 'flask') : '';
    loopBundleVariantID.length > 1 ? addLoopComponent(loopIndividualVariantID, '', 'flask') : '';
    (bootVariantID.length > 1 && bottleSizeOption != '64oz') && (bootVariantID.length > 1 && bottleSizeOption != '40oz') ? addBootComponent(bootVariantID, bundleID, 'flask') : '';
    if (bottleSizeOption != '30oz') engravingValue.length > 1 ? addEngravingComponent('40526024867958', '', bottleEngravingID, engravingValue, 'flask', engravingPlacement, engravingColor, engravingOrientation, engravingFont) : '';
  }
  

  if(flaskGiftNote.length > 0){
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note: flaskGiftNote
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log('Cart updated:', cart);
      })
      .catch((error) => {
        console.error('Error updating cart note:', error);
      });
    
  }
  let cartResponse;
  // console.log('formData', formData)
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json().then(data => {
      cartResponse = data;
      return data;
    });
    
  })
  .then(data => {
    if(method == 'confirm'){

    }else{
      popupCheckout.classList.remove('show');
      document.querySelector('.preview-popup .popup-wrapper').classList.remove('loading-icon');
    }
    formData = {
      'items': []
     };

    if(data.status == 422){
      const overLimitComponent = data.description;
      if(overLimitComponent.includes('Cap')){
        capIsAvailable = false;
      }
      if(overLimitComponent.includes('Boot')){
        bootIsAvailable = false;
      }
      if(overLimitComponent.includes('Bottle')){
        bottleIsAvailable = false;
      }
      if(overLimitComponent.includes('Loop')){
        loopIsAvailable = false;
      }
      
      checkoutOOS(true);
    }
    if(method == 'confirm'){

    }else{
      reset();
      document.querySelector('.preview-popup .popup-wrapper').classList.remove('loading-icon');
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    
  });

  // if(gliderActive){

  //   await removeStraw();
  //   console.log('gliderActive', gliderActive);
  // }
  return cartResponse.status;
}

async function removeStraw() {
  // First, get the current cart
  return fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((cart) => {
      // Find the straw item in the cart
      const strawItem = cart.items.find(item => item.id === 42526525685878);
      
      if (strawItem) {
        const currentQuantity = strawItem.quantity;
        const newQuantity = Math.max(0, currentQuantity - 1); // Ensure quantity doesn't go below 0
        
        // Update the cart with the new quantity using the key
        const updateData = {
          id: strawItem.key, // Use the key instead of the variant ID
          quantity: newQuantity,
        };

        return fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        });
      } else {
        console.log("Straw not found in cart");
        return Promise.resolve();
      }
    })
    .then((res) => {
      if (res && res.status === 200) {
        console.log("Straw quantity updated successfully");
      }
    })
    .catch((err) => console.error("Error updating straw quantity:", err));
}

const oosModal = document.querySelector('.oos-section');
let overLimitStock = false;
// bottleIsAvailable && !bootIsAvailable && loopIsAvailable && capIsAvailable && engravingIsValid
function checkoutOOS(overlimit = false, sizetransition = false){
  
  oosModal.style.transform = 'translateY(0)';
    oosModal.classList.add('show');
  
    document.querySelector('#oosc-bottle').innerText = chosenBottle;
    document.querySelector('#oosc-cap').innerText = chosenCap;
    document.querySelector('#oosc-boot').innerText = chosenBoot;
    document.querySelector('#oosc-loop').innerText = chosenLoop;

    if(overlimit){

      if(bootIsAvailable)
        document.querySelector('.oosc--boot').classList.add('hidden')
      else
      document.querySelector('.oosc--boot').classList.remove('hidden')
      
      if(bottleIsAvailable)
        document.querySelector('.oosc--bottle').classList.add('hidden')
      else
      document.querySelector('.oosc--bottle').classList.remove('hidden')

      if(loopIsAvailable)
        document.querySelector('.oosc--loop').classList.add('hidden')
      else
        document.querySelector('.oosc--loop').classList.remove('hidden')

      if(capIsAvailable)
        document.querySelector('.oosc--cap').classList.add('hidden')
      else
        document.querySelector('.oosc--cap').classList.remove('hidden')

      document.querySelector('.oos_title').innerText = 'You have reached the maximum quantity for the following items';
      document.querySelector('.oos_subcopy').innerText = '';
      document.querySelector('#edit-oos-flask').innerText = 'Select another color';
      overLimitStock = true;
    }
    else{

      if(sizetransition){
        if(loopIsAvailable)
          document.querySelector('.oosc--loop').classList.add('hidden')
        if(capIsAvailable)
          document.querySelector('.oosc--cap').classList.add('hidden')
      }
      else{
        if(bootIsAvailable)
          document.querySelector('.oosc--boot').classList.remove('hidden')
        if(bottleIsAvailable)
          document.querySelector('.oosc--bottle').classList.remove('hidden')
        if(loopIsAvailable)
          document.querySelector('.oosc--loop').classList.remove('hidden')
        if(capIsAvailable)
          document.querySelector('.oosc--cap').classList.remove('hidden')
      }
        document.querySelector('.oos_title').innerText = 'Some components are not available.';
        document.querySelector('.oos_subcopy').innerText = 'Select another color to proceed.';
        document.querySelector('#edit-oos-flask').innerText = 'Edit your flask';
        overLimitStock = false;
    }

      if(withBoot){

        document.querySelector('.oos_component.oosc--boot').style.display = 'flex';
      }else{
        document.querySelector('.oos_component.oosc--boot').style.display = 'none';
      }

    document.querySelectorAll('.oos_component').forEach((component) => {
      component.classList.remove('unavailable');
    });

    if (!bootIsAvailable){
      removeSectionActive('boot');
    }
    if (!loopIsAvailable){
      removeSectionActive('loop');
    }
    if (!capIsAvailable){
      removeSectionActive('cap');
    }
    if (!bottleIsAvailable){
      
      removeSectionActive('bottle');
    }
    // customizationMain.scrollTop = +99999;
  }

document.querySelector('#edit-oos-flask').addEventListener('click', (e) => {

  // if(overLimitStock){
  //   location.href = '/cart';
  // }
  // else{
  
    oosModal.classList.remove('show');
    setTimeout(() => {
      oosModal.style.transform = 'translateY(100%)';
    }, 400);
  // }
});
// preview-components
function removeSectionActive(tab){
  
  document.querySelector(`.oos_component.oosc--${tab}`).classList.add('unavailable');

  if(window.innerWidth < 900){
    document.querySelector(`input#${tab}-tab`).click();
  }
  else{
    document.querySelectorAll('.summary-content').forEach((component) => {
      component.classList.remove('active');
    });
    
    document.querySelectorAll('.preview-components').forEach((component) => {
      component.classList.remove('active');
    });
    document.querySelectorAll('.slider-nav').forEach((component) => {
      component.classList.remove('active');
    });
    document.querySelectorAll('.preview-main-image').forEach(e => {e.classList.remove('active');});
    document.querySelector(`.${tab}-section`).classList.add('active');
      
    document.querySelector(`.main-image-${tab}`).classList.add('active');
    document.querySelector(`.summary-content.${tab}-section`).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    // Handle slider nav based on component type
    // Cap and loop use shared nav, bottle and boot use size-specific nav
    const sharedNavComponents = ['cap', 'loop'];
    
    if (sharedNavComponents.includes(tab)) {
      // Cap and loop use shared nav without size suffix
      document.querySelector(`.slider-nav.${tab}-previous`).classList.add('active');
      document.querySelector(`.slider-nav.${tab}-next`).classList.add('active');
    } else if (tab == 'bottle') {
      // Bottle has size-specific nav
      const bottleNavSize = bottleSizeOption || '32oz';
      document.querySelector(`.slider-nav.${tab}-previous-${bottleNavSize}`)?.classList.add('active');
      document.querySelector(`.slider-nav.${tab}-next-${bottleNavSize}`)?.classList.add('active');
    } else if (tab == 'boot') {
      // Boot: 16oz/25oz/30oz share 25oz nav, 32oz has its own nav, 40oz/64oz have no boot
      if (bottleSizeOption == '40oz' || bottleSizeOption == '64oz') {
        // No boot nav for 40oz/64oz
      } else {
        const bootNavSize = (bottleSizeOption == '32oz') ? '32oz' : '25oz';
        document.querySelector(`.slider-nav.${tab}-previous-${bootNavSize}`)?.classList.add('active');
        document.querySelector(`.slider-nav.${tab}-next-${bootNavSize}`)?.classList.add('active');
      }
    } else {
      // Fallback for other components
      document.querySelector(`.slider-nav.${tab}-previous`)?.classList.add('active');
      document.querySelector(`.slider-nav.${tab}-next`)?.classList.add('active');
    }

    if(tab == 'loop'){
      if(getCapType() == 'robo'){
        tab = 'connector';
      }
    }
    if(tab == 'cap'){
      if(getCapType() == 'robo'){
        tab = 'robocap';
      } else if(getCapType() == 'bubble'){
        tab = 'bubblecap';
      }
    }
    
    // Consolidated components (caps, loops) don't use size categories anymore
    const consolidatedComponents = ['cap', 'robocap', 'bubblecap', 'loop', 'connector', 'band'];
    
    if (consolidatedComponents.includes(tab)) {
      // Just activate the preview without size category check
      document.querySelector(`.${tab}-preview`).classList.add('active');
    } else if (bottleSizeOption == '25oz') {
      document.querySelector(`.${tab}-preview[data-size-category="25oz"]`).classList.add('active');
    } else if (bottleSizeOption == '16oz') {
      document.querySelector(`.${tab}-preview[data-size-category="16oz"]`).classList.add('active');
    } else if (bottleSizeOption == '30oz') {
      document.querySelector(`.${tab}-preview[data-size-category="30oz"]`).classList.add('active');
    } else if (bottleSizeOption == '40oz') {
      document.querySelector(`.${tab}-preview[data-size-category="40oz"]`).classList.add('active');
    } else if (bottleSizeOption == '64oz') {
      document.querySelector(`.${tab}-preview[data-size-category="64oz"]`).classList.add('active');
    } else if (tab == 'boot') {
        if (withBoot) {
            setTimeout(function() {
                bootSection.click();
            }, 100);
        }
    
        if (customizationMain.classList.contains('hide-32_colors') && unavailable32OZColors.includes(chosenBoot)) {
            document.querySelector(`.${tab}-preview[data-size-category="25oz"]`).classList.add('active');
            bottlePreview.classList.remove('active');
            bottlePreview32oz.classList.remove('active');
        } else {
            document.querySelector(`.${tab}-preview[data-size-category="32oz"]`).classList.add('active');
            bottlePreview.classList.remove('active');
            bottlePreview32oz.classList.remove('active');
        }
    } else {
        document.querySelector(`.${tab}-preview[data-size-category="32oz"]`).classList.add('active');
    }
  
    
  }
}